import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import logo from '../images/logo-white.png';

library.add(fab)

class Home extends Component {
  render() {
      return (
        <BrowserRouter>
        <Grid className="home-body">
          <Row className="about-me-row">
            <Col className="">
            <p className='name-line'>D'Andre Hogan</p>
            <p className='about-me-summary'>Digital Marketing Professional</p>
            </Col>
          </Row>
          <Row className="icon-row">
            <Col className="columns" id="github-logo">
            <a className="icon-link" href="https://github.com/Dhogan92" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="icon" icon={['fab', 'github-alt']}/></a>
            </Col>
            <Col className="columns" id="behance-logo">
            <a className="icon-link"  href="https://www.behance.net/dhogan9270e5" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="icon" icon={['fab', 'behance']}/></a>
            </Col>
            <Col className="columns" id="linkedin-logo">
            <a className="icon-link" href="https://www.linkedin.com/in/d-andre-hogan-a978b285/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="icon" icon={['fab', 'linkedin']}/></a>
            </Col>
          </Row>
        </Grid>
        </BrowserRouter>
    );
  }
}

export default Home;
